import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

function DialogItemCreate({ open, onClose, createComponent }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>{createComponent}</DialogContent>
    </Dialog>
  );
}

export default DialogItemCreate;
